<template>
	<div class="voluntaryyouth ">
		<div class="topcon">
			<img src="../../assets/img/youthtop.jpg" />
		</div>

<!--		<div class="imgcon">-->
<!--			<div class="black_c">-->
<!--				<div class="name">志愿者服务数据可视化平台</div>-->
<!--				<div class="mapcon">-->
<!--					<div class="l_c">-->
<!--						<div class="top">-->
<!--							<img src="../../assets/img/mapa@2x.png" />-->
<!--							<div class="textcon">-->
<!--								<div class="title">注册志愿者人数</div>-->
<!--								<div class="num">30万<span>人</span></div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="top">-->
<!--							<img src="../../assets/img/mapb@2x.png" />-->
<!--							<div class="textcon">-->
<!--								<div class="title">今日开展志愿者服务活动数</div>-->
<!--								<div class="num">0<span>次</span></div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--					<div class="mapimg">-->
<!--						<img src="../../assets/img/map@2x.png" />-->
<!--					</div>-->
<!--					<div class="r_c">-->
<!--						<div class="top">-->
<!--							<img src="../../assets/img/mapc@2x.png" />-->
<!--							<div class="textcon">-->
<!--								<div class="title">累计参与志愿服务人数达</div>-->
<!--								<div class="num">150万<span>人</span></div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="top">-->
<!--							<img src="../../assets/img/mapd@2x.png" />-->
<!--							<div class="textcon">-->
<!--								<div class="title">提供志愿服务时长</div>-->
<!--								<div class="num">440余万<span>小时</span></div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->

		<div class="carcon">
			<div class="heatnews">
				<heatnews></heatnews>
			</div>

		</div>

	</div>

</template>

<script>

import actlist from '@/components/helppart/actlist.vue'
import heatnews from '@/components/helppart/heatnews.vue'
export default {
  components:{actlist,heatnews},
  computed:{

  },
  data: function() {
		return {
		};
  },

  created() {
  },

  methods: {
  },


};
</script>

<style scoped="scoped" lang="scss">

.voluntaryyouth{
	position: relative;
	margin: auto;
	height: 100%;
	.topcon{
		display: flex;
		justify-content: center;
		img{
			width: 1200px;
			height: 448px;
		}

	}

	.imgcon{
		width: 100%;
		height: 644px;
		background: url(../../assets/img/mapbg@2x.png) no-repeat top center/ 100% 100%;
		display: flex;
		justify-content: center;
		.black_c{
			width: 1200px;
			height: 644px;
			.name{
				text-align: center;
				height: 100px;
				line-height: 100px;
				font-size: 30px;
				font-weight: 400;
				color: #333333;
			}

			.mapcon{
				margin-top: 40px;
				display: flex;
				.l_c{
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					.top{
						display: flex;
						align-items: flex-end;
						img{
							width: 40px;
							height: 40px;
						}
						.textcon{
							margin-left: 10px;
							display: flex;
							flex-direction: column;
							.title{
								font-size: 16px;
								font-weight: 400;
								color: #333333;
								margin-bottom: 10px;
							}
							.num{
								font-size: 24px;
								font-weight: bold;
								color: #333333;
								span{
									font-size: 16px;
									font-weight: 400;
									color: #333333;
								}
							}
						}
					}

				}
				.mapimg{
					width: 560px;
					margin-right: 70px;
					img{
						width: 542px;
						height: 399px;
					}
				}
				.r_c{
					flex: 0.7;
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					// align-items: flex-end;
					.top{
						display: flex;
						align-items: flex-end;
						img{
							width: 40px;
							height: 40px;
						}
						.textcon{
							margin-left: 10px;
							display: flex;
							flex-direction: column;
							.title{
								font-size: 16px;
								font-weight: 400;
								color: #333333;
								margin-bottom: 10px;
							}
							.num{
								font-size: 24px;
								font-weight: bold;
								color: #333333;
								span{
									font-size: 16px;
									font-weight: 400;
									color: #333333;
								}
							}
						}
					}

				}
			}
		}
	}


	.carcon{
		display: flex;
		align-items: center;
		flex-direction: column;
		.activities{
			margin-top: 60px;
			width: 1200px;
		}

		.heatnews{
			margin-top: 20px;
			width: 1200px;
			margin-bottom: 40px;
		}

	}




}

</style>
